package ui.app.assign.detail.kindergarten.editor

import androidx.compose.runtime.*
import io.Repository
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.StringResource
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.await
import ui.snackBarStateGlobal

@VM
class AppKindergartenEditorVM : NavigationViewModel() {

    private lateinit var scopeUi: AppKindergartenEditorScope

    var state by mutableDataState<AppKindergartenEditorScope.Wrapper>()
        private set

    var tabs by mutableStateOf<List<Tab>>(listOf())
        private set

    var tabIndex by mutableStateOf(0)
        private set

    sealed class Tab(val name: StringResource) {
        object General00 : Tab(Res.string.layer_bottom_detail_editor__page_general)
        object Devices01 : Tab(Res.string.layer_bottom_detail_editor__page_devices)
        object Wireframe02 : Tab(Res.string.layer_bottom_detail_editor__page_wireframe)
        object Pictures03 : Tab(Res.string.layer_bottom_detail_editor__page_pictures)
        object Pictures04 : Tab(Res.string.layer_bottom_detail_editor__page_icons)
        object Audio05 : Tab(Res.string.layer_bottom_detail_editor__page_audio)
        object Summary06 : Tab(Res.string.layer_bottom_detail_editor__page_summary)
    }

    sealed interface Action {
        data object Save : Action
        data object PageNext : Action
        data object PageLast : Action
        data class PageExact(val index: Int) : Action

        companion object {


            @Composable
            fun rememberAction(vm: AppKindergartenEditorVM): (Action) -> Unit {
                val nav = LocalNavigation.current
                return remember {
                    { act ->
                        when (act) {
                            Save -> vm.save(nav)
                            is PageExact -> vm.tabIndex = act.index
                            PageNext -> {
                                vm.tabIndex = (vm.tabIndex + 1)
                                    .takeIf { it < vm.tabs.size }
                                    ?: vm.tabIndex
                            }
                            PageLast -> {
                                vm.tabIndex = vm.tabs.lastIndex
                            }
                        }
                    }
                }
            }
        }
    }

    fun init(scopeUi: AppKindergartenEditorScope) {
        this.scopeUi = scopeUi
        if (state is DataState.Result) return

        scope.launch {
            runCatching {
                tabs = listOf(
                    Tab.General00,
                    Tab.Devices01,
                    Tab.Wireframe02,
                    Tab.Pictures03,
                    Tab.Pictures04,
                    Tab.Audio05,
                    Tab.Summary06,
                )
                Repository.api.app.single(scopeUi.args.companyId, scopeUi.args.appId)
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error("Connection fail ${it.message}")
            }.onSuccess {
                state = DataState.Result(
                    AppKindergartenEditorScope.Wrapper(data = it).apply {
                        setupLabels()
                    }
                )
            }
        }
    }

    private fun save(nav: Navigation) {
        scope.launch {
            state.entry?.apply {
                runCatching {
                    Repository.api.app.edit(scopeUi.args.companyId, data)
                }.onFailure {
                    it.printStackTrace()
                    snackBarStateGlobal.showSnackbar(
                        message = it.message ?: "Fail to save",
                        withDismissAction = true
                    )
                }.onSuccess {
                    launch {
                        snackBarStateGlobal.showSnackbar(
                            message = Res.string.dialog__action_saved.await(),
                            withDismissAction = false
                        )
                    }
                    nav.up()
                }
            }
        }
    }

    override fun onRelease() {
        state = DataState.Idle()
    }
}
